import React from "react";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Tooltip from "@mui/material/Tooltip";
import "./PermissionTable.css";

const PermissionTable = ({
  items,
  hasEnableDisable = false,
  permissions,
  togglePermission,
}) => {
  const actionMapping = {
    view: "View",
    edit: "Edit",
    create: "Create",
    delete: "Delete",
    enable: "EnableAndDisable",
  };

  const getPermissionKey = (itemId, action) =>
    `${itemId}.${actionMapping[action]}`;

  const isPermissionActive = (itemId, action) =>
    permissions[getPermissionKey(itemId, action)] === true;

  const handleAllCheckbox = (itemId) => {
    const actions = ["view", "edit", "create", "delete"];
    if (hasEnableDisable) actions.push("enable");

    const allSelected = actions.every((a) => isPermissionActive(itemId, a));

    actions.forEach((a) => {
      const key = getPermissionKey(itemId, a);
      if (allSelected && permissions[key]) {
        togglePermission(key);
      } else if (!allSelected && !permissions[key]) {
        togglePermission(key);
      }
    });
  };

  const isAllSelected = (itemId) => {
    const actions = ["view", "edit", "create", "delete"];
    if (hasEnableDisable) actions.push("enable");
    return actions.every((a) => isPermissionActive(itemId, a));
  };

  const isIndeterminate = (itemId) => {
    const actions = ["view", "edit", "create", "delete"];
    if (hasEnableDisable) actions.push("enable");
    const selected = actions.filter((a) => isPermissionActive(itemId, a));
    return selected.length > 0 && selected.length < actions.length;
  };

  const getSelectedPermissionsString = (itemId) => {
    const actions = ["view", "edit", "create", "delete"];
    if (hasEnableDisable) actions.push("enable");
    const selected = actions.filter((a) => isPermissionActive(itemId, a));
    return selected.length > 0 ? selected.join(", ") : "none";
  };

  return (
    <div>
      <table className="permission-table">
        <thead>
          <tr className="permission-header">
            <th className="permission-header-cell">Type</th>
            <th className="permission-header-cell">All</th>
            <th className="permission-header-cell">View</th>
            <th className="permission-header-cell">Edit</th>
            <th className="permission-header-cell">Create</th>
            <th className="permission-header-cell">Delete</th>
            {hasEnableDisable && (
              <th className="permission-header-cell">Enable / Disable</th>
            )}
          </tr>
        </thead>
        <tbody>
          {items.map((item) => (
            <tr key={item.id} className="permission-row">
              <td className="permission-cell permission-type-cell">
                {item.label}

                {/* Tooltip for Amazon Q */}
                {["QConnectAIAgents", "QConnectAIPrompts", "QConnectGuardrails"].includes(
                  item.id
                ) && (
                  <Tooltip title="Configure access to Amazon Q features" arrow>
                    <InfoOutlinedIcon
                      style={{
                        fontSize: 16,
                        marginLeft: 4,
                        verticalAlign: "middle",
                        cursor: "pointer",
                      }}
                    />
                  </Tooltip>
                )}
{/* 
                <div style={{ fontSize: 10, color: "#666", marginTop: 2 }}>
                  Selected: {getSelectedPermissionsString(item.id)}
                </div> */}
              </td>

              {/* All */}
              <td className="permission-cell">
                <input
                  type="checkbox"
                  className="permission-checkbox"
                  checked={isAllSelected(item.id)}
                  ref={(el) => {
                    if (el) el.indeterminate = isIndeterminate(item.id);
                  }}
                  onChange={() => handleAllCheckbox(item.id)}
                />
              </td>

              {/* Individual */}
              {["view", "edit", "create", "delete"].map((action) => (
                <td key={action} className="permission-cell">
                  <input
                    type="checkbox"
                    className="permission-checkbox"
                    checked={isPermissionActive(item.id, action)}
                    onChange={() =>
                      togglePermission(getPermissionKey(item.id, action))
                    }
                  />
                </td>
              ))}

              {hasEnableDisable && (
                <td className="permission-cell">
                  <input
                    type="checkbox"
                    className="permission-checkbox"
                    checked={isPermissionActive(item.id, "enable")}
                    onChange={() =>
                      togglePermission(getPermissionKey(item.id, "enable"))
                    }
                  />
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PermissionTable;
